module.exports = __webpack_public_path__ + "static/media/Questions.5cb300a2.svg";